import React from 'react';
import { Link } from 'react-router-dom';
import { AiFillHome } from 'react-icons/ai';
import { IoIosArrowForward } from 'react-icons/io';

const Breadcrumbs = ({ items }) => {
    return (
        <nav className="flex items-center text-sm" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2">
                {items.map((item, index) => (
                    <li key={index} className="inline-flex items-center">
                        {index === 0 ? (
                            <Link
                                to={item.link || '#'}
                                className="inline-flex items-center text-gray-500 hover:text-primary transition-colors"
                            >
                                <AiFillHome className="mr-2" />
                                {item.name}
                            </Link>
                        ) : (
                            <div className="flex items-center">
                                <IoIosArrowForward className="mx-1 text-gray-400" />
                                {item.link ? (
                                    <Link
                                        to={item.link}
                                        className="ml-1 text-gray-500 hover:text-primary transition-colors"
                                    >
                                        {item.name}
                                    </Link>
                                ) : (
                                    <span className="ml-1 text-gray-700 font-medium">
                                        {item.name}
                                    </span>
                                )}
                            </div>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;